// import React, { useState } from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const cardDesigns = [
//   {
//     name: 'Modern',
//     theme: 'light',
//     primary: '#4F46E5',
//     secondary: '#06B6D4',
//   },
//   {
//     name: 'Professional',
//     theme: 'light',
//     primary: '#1E293B',
//     secondary: '#0EA5E9',
//   },
//   {
//     name: 'Creative',
//     theme: 'dark',
//     primary: '#A855F7',
//     secondary: '#EC4899',
//   },
//   {
//     name: 'Minimal',
//     theme: 'dark',
//     primary: '#10B981',
//     secondary: '#14B8A6',
//   },
// ];

// export function TwoClicks() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.2,
//   });

//   const [currentIndex, setCurrentIndex] = useState(0);

//   const next = () => {
//     setCurrentIndex((prev) => (prev + 1) % cardDesigns.length);
//   };

//   const prev = () => {
//     setCurrentIndex((prev) => (prev - 1 + cardDesigns.length) % cardDesigns.length);
//   };

//   return (
//     <section className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20 relative overflow-hidden">
//       <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-accent/5 dark:from-primary/10 dark:to-accent/10" />

//       <div className="max-w-6xl mx-auto relative">
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-12"
//         >
//           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
//             Achieving Design in{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               Two Clicks
//             </span>
//           </h2>
//           <p className="text-lg text-muted-foreground">
//             Choose from beautiful pre-designed templates
//           </p>
//         </motion.div>

//         {/* Carousel */}
//         <div className="relative">
//           <div className="overflow-hidden">
//             <motion.div
//               className="flex gap-6"
//               animate={{ x: `-${currentIndex * 100}%` }}
//               transition={{ type: 'spring', stiffness: 300, damping: 30 }}
//             >
//               {cardDesigns.map((design, index) => (
//                 <motion.div
//                   key={design.name}
//                   className="min-w-full sm:min-w-[calc(50%-12px)] lg:min-w-[calc(33.333%-16px)] flex-shrink-0"
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={inView ? { opacity: 1, scale: 1 } : {}}
//                   transition={{ delay: index * 0.1 }}
//                 >
//                   <div
//                     className={`${
//                       design.theme === 'dark' ? 'bg-gray-900' : 'bg-white'
//                     } rounded-2xl p-8 shadow-2xl border ${
//                       design.theme === 'dark' ? 'border-gray-800' : 'border-gray-200'
//                     } transition-transform hover:scale-105 duration-300`}
//                   >
//                     <div className="space-y-4">
//                       <div className="flex items-center gap-4">
//                         <div
//                           className="w-16 h-16 rounded-full"
//                           style={{
//                             background: `linear-gradient(135deg, ${design.primary}, ${design.secondary})`,
//                           }}
//                         />
//                         <div>
//                           <h3
//                             className={`font-bold text-lg ${
//                               design.theme === 'dark' ? 'text-white' : 'text-gray-900'
//                             }`}
//                           >
//                             {design.name} Card
//                           </h3>
//                           <p
//                             className={
//                               design.theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
//                             }
//                           >
//                             Creative Professional
//                           </p>
//                         </div>
//                       </div>
//                       <div
//                         className="h-px"
//                         style={{ backgroundColor: design.primary + '20' }}
//                       />
//                       <div
//                         className={`space-y-2 text-sm ${
//                           design.theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
//                         }`}
//                       >
//                         <p>📧 hello@example.com</p>
//                         <p>📱 +1 (555) 000-0000</p>
//                         <p>🌐 example.com</p>
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </div>

//           {/* Navigation Buttons */}
//           <button
//             onClick={prev}
//             className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 p-3 bg-card border border-border rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110"
//             aria-label="Previous"
//           >
//             <ChevronLeft className="w-6 h-6 text-foreground" />
//           </button>
//           <button
//             onClick={next}
//             className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 p-3 bg-card border border-border rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110"
//             aria-label="Next"
//           >
//             <ChevronRight className="w-6 h-6 text-foreground" />
//           </button>

//           {/* Dots Indicator */}
//           <div className="flex justify-center gap-2 mt-8">
//             {cardDesigns.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentIndex(index)}
//                 className={`h-2 rounded-full transition-all duration-300 ${
//                   index === currentIndex
//                     ? 'w-8 bg-gradient-to-r from-primary to-accent'
//                     : 'w-2 bg-border'
//                 }`}
//                 aria-label={`Go to slide ${index + 1}`}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }



import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

/* CARD DATA */
const cardDesigns = [
  {
    name: "Modern",
    theme: "light",
    primary: "#4F46E5",
    secondary: "#06B6D4",
  },
  {
    name: "Professional",
    theme: "light",
    primary: "#1E293B",
    secondary: "#0EA5E9",
  },
  {
    name: "Creative",
    theme: "dark",
    primary: "#A855F7",
    secondary: "#EC4899",
  },
  {
    name: "Minimal",
    theme: "dark",
    primary: "#10B981",
    secondary: "#14B8A6",
  },
];

const TwoClicks = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [inView, setInView] = useState(false);

  /* SCROLL ANIMATION */
  useEffect(() => {
    const onScroll = () => {
      const section = document.getElementById("two-clicks");
      if (!section) return;

      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        setInView(true);
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const next = () =>
    setCurrentIndex((prev) => (prev + 1) % cardDesigns.length);

  const prev = () =>
    setCurrentIndex(
      (prev) => (prev - 1 + cardDesigns.length) % cardDesigns.length
    );

  return (
    <section
      id="two-clicks"
      style={{
        padding: "80px 16px",
        background:
          "linear-gradient(to bottom, rgba(99,102,241,0.05), rgba(34,211,238,0.05))",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          style={{ textAlign: "center", marginBottom: "48px" }}
        >
          <h2 style={{ fontSize: "2.75rem", fontWeight: "bold", color: "#111" }}>
            Achieving Design in{" "}
            <span
              style={{
                background: "linear-gradient(to right, #6366f1, #22d3ee)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Two Clicks
            </span>
          </h2>
          <p style={{ color: "#6b7280", fontSize: "1.125rem" }}>
            Choose from beautiful pre-designed templates
          </p>
        </motion.div>

        {/* SLIDER */}
        <div style={{ position: "relative" }}>
          <div style={{ overflow: "hidden" }}>
            <motion.div
              style={{ display: "flex" }}
              animate={{ x: `-${currentIndex * 100}%` }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              {cardDesigns.map((design, index) => {
                const dark = design.theme === "dark";

                return (
                  /* SLIDE (100% WIDTH FOR ANIMATION) */
                  <div
                    key={index}
                    style={{
                      minWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {/* REAL CARD */}
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={inView ? { opacity: 1, scale: 1 } : {}}
                      transition={{ delay: index * 0.1 }}
                      style={{
                        width: "360px",
                        padding: "28px",
                        borderRadius: "20px",
                        background: dark ? "#111827" : "#ffffff",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                        border: dark
                          ? "1px solid #1f2937"
                          : "1px solid #e5e7eb",
                        color: dark ? "#fff" : "#111",
                      }}
                    >
                      {/* CARD HEADER */}
                      <div style={{ display: "flex", gap: "16px" }}>
                        <div
                          style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "50%",
                            background: `linear-gradient(135deg, ${design.primary}, ${design.secondary})`,
                          }}
                        />
                        <div>
                          <h3 style={{ fontWeight: "bold" }}>
                            {design.name} Card
                          </h3>
                          <p style={{ color: dark ? "#9ca3af" : "#6b7280" }}>
                            Creative Professional
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          height: "1px",
                          background: design.primary + "33",
                          margin: "16px 0",
                        }}
                      />

                      {/* CARD INFO */}
                      <div
                        style={{
                          fontSize: "0.875rem",
                          color: dark ? "#9ca3af" : "#6b7280",
                        }}
                      >
                        <p>📧 hello@example.com</p>
                        <p>📱 +1 (555) 000-0000</p>
                        <p>🌐 example.com</p>
                      </div>
                    </motion.div>
                  </div>
                );
              })}
            </motion.div>
          </div>

          {/* NAV BUTTONS */}
          <button
            onClick={prev}
            style={{
              position: "absolute",
              left: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              padding: "10px",
              border: "1px solid #e5e7eb",
              cursor: "pointer",
            }}
          >
            <ChevronLeft />
          </button>

          <button
            onClick={next}
            style={{
              position: "absolute",
              right: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "#fff",
              borderRadius: "50%",
              padding: "10px",
              border: "1px solid #e5e7eb",
              cursor: "pointer",
            }}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TwoClicks;

